import type {HorseRaceExtended} from "@atg-tillsammans/game-types";
import type {GlobalGameState} from "../../common/redux/gameTypes";

export const getExtendedRaceById = (
    state: GlobalGameState,
    raceId: string,
): HorseRaceExtended | null => state.game.horse.races[raceId] || null;
